import { CartService, CartServiceModule } from '@b2b/common/services';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import { OrderContact } from '@b2b/types/order';
import { Organization } from '@b2b/types/organization';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IIntervalService, ILogService, ITimeoutService, growl } from 'angular';
import { CartDirectiveModule } from '../cart/cart.directive';

HeaderDirective.$inject = [
  '$log',
  '$uibModal',
  '$state',
  '$timeout',
  '$interval',
  'growl',
  'AuthService',
  'AuthenticationService',
  'ApiService',
  'ConfigService',
  'CartService',
  'FeatureToggleService',
  'HelpersService',
  'ThemesHelperService',
];

function HeaderDirective(
  $log: ILogService,
  $uibModal: UIBModalService,
  $state: StateService,
  $timeout: ITimeoutService,
  $interval: IIntervalService,
  growl: growl.IGrowlService,
  AuthService: TODO,
  authenticationService: AuthenticationService,
  ApiService: TODO,
  ConfigService: TODO,
  CartService: CartService,
  FeatureToggleService: TODO,
  HelpersService: TODO,
  ThemesHelperService: TODO
) {
  HeaderController.$inject = ['$scope'];

  function HeaderController($scope) {
    let user = authenticationService.getUserFromCookie();
    let csr = authenticationService.getCSRUserFromCookie();

    const ctrl = {
      config: {},
      inviteModal: {} as UIBModal<any>,

      print: false,
      minimal: false,

      isCheckTimerRunning: false,
      cartHint: 'View Cart',
      viewCartHint: 'View Cart',
      emptyCartHint: 'Cart is empty',

      user: user,
      csr: csr,
      hasUserProfileName: false,
      isLoggedIn: user && (user.hasOwnProperty('email') || user.hasOwnProperty('userName')),
      isCartOpen: false,
      cartItemCount: 0,
      cartInitted: false,
      cartService: CartService,
      hideSpinner: false,
      spinnerTimer: null as angular.IPromise<void> | null,
      cartInitTimer: null as angular.IPromise<void> | null,
      useCart: false,
      orderContact: {} as Partial<OrderContact> | null,
      organization: {} as Partial<Organization>,
      growlCartMessage: {} as growl.IGrowlMessage,

      hideItems: false,

      init: function () {
        ctrl.config = ConfigService.get('directives', 'header');
        ctrl.print = $scope.print;
        ctrl.minimal = $scope.minimal;
        ctrl.useCart = FeatureToggleService.check('TENANT_CART');

        $scope.$on('header::message', this.onShowMessage);
        $scope.$on('AppController::logout::success', this.onLogoutSuccess);
        $scope.$on('AppController::login::success', this.onLoginSuccess);
        $scope.$on('AppController::cart::open', this.onCartOpen);
        $scope.$on('AppController::cart::close', this.onCartClose);
        $scope.$on('AppController::cart::toggle', this.onCartToggle);
        $scope.$on('$destroy', $scope.$watch('header.cartService.itemCount', this.onCartServiceItemCountUpdate));
        $scope.$on('$destroy', $scope.$watch('header.cartService.events.events.length', this.onCartEventsChanged));
        $scope.$on('$destroy', $scope.$watch('header.cartService.initted', this.onCartServiceInitted));
        $scope.$on('$destroy', $scope.$watch('header.hideItems', this.onHideItemsUpdate));
        $scope.$on(
          '$destroy',
          $scope.$watchCollection('header.cartService.orderContact', this.onCartServiceOrderContactUpdated)
        );
        $scope.$on(
          '$destroy',
          $scope.$watchCollection('header.cartService.organization', this.onCartServiceOrganizationUpdate)
        );
        $scope.$on('$destroy', this.killTimers);
      },

      killTimers: function () {
        if (ctrl.spinnerTimer) {
          $timeout.cancel(ctrl.spinnerTimer);
        }
        if (ctrl.cartInitTimer) {
          $timeout.cancel(ctrl.cartInitTimer);
        }
      },

      updateCartHint: function (hint) {
        this.cartHint = this.cartService.itemCount || this.cartService.events.events.length ? hint : this.emptyCartHint;
      },

      getTemplate: function () {
        let result = 'common/directives/header/';

        if (this.print) {
          result += 'print';
        } else if (this.minimal) {
          result += 'minimal';
        } else {
          result += 'application';
        }

        result += '.tpl.html';

        return result;
      },

      launchCart: function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.cartService.itemCount || this.cartService.events.events.length) {
          const organization = this.cartService.getOrganization();

          if (organization && organization.id) {
            this.isCartOpen = true;
          } else {
            $state.go('application.cart');
          }
        }
      },

      refresh: function () {
        window.location.reload();
        $state.go($state.current, $state.params, {
          notify: true,
          reload: true,
          inherit: false,
        });
      },

      printPage: function () {
        $scope.$emit('Header::print');
      },

      getUserFullName: function () {
        return authenticationService.getUserFullName();
      },
      getFullName: function (contact) {
        return HelpersService.getFullName(contact);
      },

      getConfig: function (name) {
        let result = false;

        if (this.config.hasOwnProperty(name)) {
          result = this.config[name];
        }

        return result;
      },

      getHomeLink: function () {
        return AuthService.getHomeUrl();
      },

      getCompanyName: function () {
        return ThemesHelperService.getCompany('name') || 'Tenant ID: ' + this.user.tenantId;
      },

      logout: function () {
        user = null;
        csr = null;
        this.user = user;
        this.csr = csr;
        this.isLoggedIn = false;
      },

      onLogoutSuccess: function (e, data) {
        ctrl.logout();
      },

      onLoginSuccess: function (e, data) {
        console.log('header::onLoginSuccess');
      },

      /**
       * Opens cart and invokes growl notification
       * data parameter requires itemName and assumes
       * a cart item otherwise defaults to 'Item'
       */
      onCartOpen: function (e, data) {
        const name = (data && data.itemName) || 'Item';

        ctrl.showMessage({ message: name + ' added to the cart.', fallback: true });

        ctrl.isCartOpen = true;
      },

      showMessage: function (data) {
        // Uses JQuery event mechanism instead of angular
        const message = data.message || '';
        const fallback = data.fallback;
        const markup =
          '<a class="header-cart-growl" onclick="event.preventDefault();event.stopPropagation();$(document).trigger(\'Header::Top\')" class="btn btn-link">' +
          '<span class="fa fa-2x fa-shopping-cart"></span> ' +
          message +
          ' </a>';

        $(document).off('Header::Top');
        $(document).on('Header::Top', function (e, id) {
          ctrl.growlCartMessage.destroy();
          if (fallback) {
            // Fallback in case user has clicked away
            ctrl.isCartOpen = true;
          }
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        });

        ctrl.growlCartMessage = growl.success(markup);
      },

      onCartClose: function (e, data) {
        ctrl.isCartOpen = false;
      },

      onCartToggle: function (e, data) {
        ctrl.isCartOpen = data.open;
      },

      onCartServiceItemCountUpdate: function (n, o) {
        if (n) {
          ctrl.cartHint = ctrl.viewCartHint;
        } else {
          ctrl.cartHint = ctrl.emptyCartHint;
        }
      },

      onCartServiceInitted: function (n, o) {
        if (n) {
          ctrl.killTimers();
          ctrl.cartInitTimer = $timeout(() => {
            ctrl.cartInitted = n;
            ctrl.spinnerTimer = $timeout(() => {
              ctrl.hideSpinner = true;
            }, 500);
          }, 1000);
        }
      },

      onCartEventsChanged: function (n, o) {
        if (n) {
          ctrl.cartHint = ctrl.viewCartHint;
        } else {
          ctrl.cartHint = ctrl.emptyCartHint;
        }
      },

      onCartServiceOrderContactUpdated: function (n, o) {
        ctrl.orderContact = ctrl.cartService.getOrderContact();
      },

      onCartServiceOrganizationUpdate: function (n, o) {
        if (n && n.id) {
          ctrl.organization = ctrl.cartService.getOrganization();
        } else {
          ctrl.organization = {};
        }
      },

      onShowMessage: function (e, data) {
        ctrl.showMessage(data);
      },

      onHideItemsUpdate: function (n, o) {
        $scope.$emit('header::hideItems', n);
      },
    };

    $scope.header = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'AE',
    replace: true,
    templateUrl: 'common/directives/header/header.tpl.html',
    scope: {
      print: '@',
      minimal: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: HeaderController,
  };
}

export const HeaderDirectiveModule = angular
  .module('acme.common.directive.header', [
    uiRouter,
    'ui.bootstrap',
    'angular-growl',
    'acme.common.service.api',
    'acme.common.service.auth',
    AuthenticationServiceModule,
    'acme.common.service.permissions',
    'acme.common.service.validate',
    'acme.common.service.config',
    CartServiceModule,
    'acme.common.service.featureToggle',
    'acme.common.service.helpers',
    CartDirectiveModule,
    'acme.common.service.themesHelper',
  ])
  .directive('header', HeaderDirective).name;
